import z from "zod";

const errorClassificationValues = [
  "VALIDATION_ERROR",
  "AUTHORIZATION_ERROR",
  "NOT_FOUND_ERROR",
  "INVALID_STATE_ERROR",
  "CONFLICT_ERROR",
  "DEPENDENCY_ERROR",
  "INTEGRATION_ERROR",
  "DATABASE_ERROR",
  "TIMEOUT_ERROR",
  "RETRYABLE_ERROR",
  "UNEXPECTED_ERROR",
] as const;

const errorClassificationSchema = z.enum(errorClassificationValues);
export const ErrorClassification = errorClassificationSchema.enum;
export type ErrorClassification = z.infer<typeof errorClassificationSchema>;

export const classificationToHttpStatus = {
  VALIDATION_ERROR: 400,
  AUTHORIZATION_ERROR: 401,
  NOT_FOUND_ERROR: 404,
  INVALID_STATE_ERROR: 400,
  CONFLICT_ERROR: 409,
  DEPENDENCY_ERROR: 500,
  INTEGRATION_ERROR: 500,
  DATABASE_ERROR: 500,
  TIMEOUT_ERROR: 504,
  RETRYABLE_ERROR: 500,
  UNEXPECTED_ERROR: 500,
} as const satisfies Record<ErrorClassification, number>;

export const ErrorClassificationDisplayName: Record<ErrorClassification, string> = {
  VALIDATION_ERROR: "ValidationError",
  AUTHORIZATION_ERROR: "AuthorizationError",
  NOT_FOUND_ERROR: "NotFoundError",
  INVALID_STATE_ERROR: "InvalidStateError",
  CONFLICT_ERROR: "ConflictError",
  DEPENDENCY_ERROR: "DependencyError",
  INTEGRATION_ERROR: "IntegrationError",
  DATABASE_ERROR: "DatabaseError",
  TIMEOUT_ERROR: "TimeoutError",
  RETRYABLE_ERROR: "RetryableError",
  UNEXPECTED_ERROR: "UnexpectedError",
};
